import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";
import OpenFileLink from "../Components/OpenFileLink";
import { dateToString, joinCss } from "../helpers/utils";
import LinesEllipsis from "react-lines-ellipsis";

import classes from "./Update.module.scss";

class update extends Component {
  render() {
    const contant = (
      <Container className={classes.Update}>
        <Row>
          <Col sm="12" className={classes.publishAt}>
            עודכן לאחרונה: {dateToString(new Date(this.props.update.publishAt))}
          </Col>
        </Row>
        <Row>
          <Col className={joinCss(classes.chapterName)} sm="12">
            <LinesEllipsis
              maxLine="2"
              text={
                this.props.update.chapterIdForName +
                " | " +
                this.props.update.chapterName
              }
            />
          </Col>
        </Row>
        <Row>
          <Col className={classes.updateFileName} sm="12">
            {this.props.update.docDescription}
          </Col>
        </Row>
      </Container>
    );
    return (
      <OpenFileLink
        componentContant
        localClass={classes.updateLink}
        linkContant={contant}
        contant={this.props.update.pdfName}
        id={this.props.update.id}
        numOfLines="2"
      />
    );
  }
}

export default update;
